import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Compass } from 'lucide-react';
import Loader from './Loader';
import { Reveal, StaggerGroup, StaggerItem, HoverLift } from './motion/Motion';
import { useSiteData } from '@/context/SiteDataContext';
import { optimizeImageUrl } from '@/lib/imageUtils';

const TopDestinations = () => {
  const scrollRef = useRef(null);
  const { destinations } = useSiteData();
  const loading = destinations.length === 0;

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 350;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const getSlug = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
  };

  if (loading) {
    return (
      <section id="destinations" className="top-destinations-section">
        <div className="section-header">
          <Compass className="section-icon" />
          <h2 className="section-title">Top Destinations for Families</h2>
          <p className="section-subtitle">Explore our most popular international destinations</p>
        </div>
        <Loader />
      </section>
    );
  }

  return (
    <section id="destinations" className="top-destinations-section">
      <Reveal className="section-header">
        <span className="section-eyebrow">Where to next</span>
        <Compass className="section-icon" />
        <h2 className="section-title display-heading">Top Destinations for Families</h2>
        <p className="section-subtitle">Explore our most popular international destinations</p>
      </Reveal>

      <div className="carousel-container">
        <button className="scroll-btn left" onClick={() => scroll('left')}>
          <ChevronLeft size={24} />
        </button>

        <StaggerGroup className="destinations-carousel" ref={scrollRef}>
          {destinations.map((destination) => (
            <StaggerItem key={destination.id} className="destination-card-link-carousel">
              <Link to={`/destinations/${getSlug(destination.name)}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                <HoverLift className="destination-card" lift={-8}>
                  <div className="destination-image-wrapper">
                    <img
                      src={optimizeImageUrl(destination.image, 500)}
                      alt={destination.name}
                      className="destination-image"
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="destination-overlay">
                      <h3 className="destination-name">{destination.name}</h3>
                      <p className="destination-country">{destination.country}</p>
                    </div>
                  </div>
                </HoverLift>
              </Link>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <button className="scroll-btn right" onClick={() => scroll('right')}>
          <ChevronRight size={24} />
        </button>
      </div>
    </section>
  );
};

export default TopDestinations;
